export const newsArticles = [
  {
    slug: "ai-education-action-plan",
    title: "五部门联合印发《“人工智能 + 教育”行动计划》",
    subtitle: "政策释放就业红利，人工智能赛道成 IT 求职新方向",
    date: "2026.04.13",
    tag: "新闻资讯",
    image: "/images/news/1.jpg",
    sections: [
      {
        paragraphs: [
          "今年4月，教育部、国家发改委、工信部、科技部、国家数据局五部门联合印发《“人工智能+教育”行动计划》，明确推动职业教育智能化升级，大力培育数字领域高技能人才。新政立足于产业发展趋势，为广大求职者、转行人员指明就业新赛道，AI相关岗位成为当下IT就业市场的热门选择。",
          "行动计划提出，要加快传统IT专业改造升级，淘汰落后技术内容，围绕人工智能产业打造“短、实、新”课程体系，坚持以项目为实战核心，深化产教融合育人模式。",
          "当前数字经济高速发展，全行业智能化转型提速，传统技术岗位逐渐缩减，而AI全栈开发、智能应用、算力运维等新型岗位需求持续爆发。结合行业调研数据，2026年国内人工智能相关技术人才缺口规模持续扩大，具备综合实操能力的从业者，在求职竞争中拥有明显优势，这也让系统的职业技能培训成为职场进阶的重要途径。",
          "紧跟国家政策导向，鑫谷程序员全面对标《“人工智能+教育”行动计划》要求，持续优化整体人才培养体系。品牌聚焦当下市场主流技术方向，依托自主研发的课程体系，紧跟行业技术迭代节奏，及时更新教学内容，确保学员所学贴合企业真实用工标准。教学全程践行实战化培养理念，将企业真实项目融入日常教学，让学员在学习阶段累积实战经验，补齐职场竞争力短板。",
          "《行动计划》强调职业教育要“联合行业企业制定人才培养方案”。鑫谷程序员积极响应政策，推进产教协同发展，联动众多科技企业共建人才培养模式，聘用行业一线技术人员授课打磨课程，打通学习与就业之间的壁垒。针对应届生、职场转行者、技术提升人群等不同群体的学习需求，打造适配的教学方案，帮助零基础学员快速入门，助力在岗人员完成技术升级。不少学员通过系统化培训，顺利入职各类科技企业，实现了职业转型与薪资提升。",
          "随着新政逐步落地，人工智能与各行业的融合还将持续加深，IT行业的人才需求结构也会进一步优化。对于正在求职、计划转行的人群而言，紧跟政策风口，掌握前沿数字技术，是抓住就业机遇的关键。",
          "未来，鑫谷程序员将继续以政策为指引，打磨教学品质、强化就业服务，持续为市场输送优质技术人才，助力更多求职者凭借过硬技能站稳数字职场，把握住人工智能时代的职业发展机遇。",
        ],
      },
    ],
  },
  {
    slug: "it-operations-career",
    title: "做IT运维岗还有前途吗？运维想要转岗都有哪些出路？",
    date: "2026.05.20",
    tag: "就业规划",
    image: "/images/news/3.jpg",
    lead: "IT运维岗仍是前景明确、薪资稳步上涨的技术岗位，但已呈现两极分化。传统运维岗位持续萎缩，AI智能运维、云原生运维等高端复合型岗位需求快速增长。",
    sections: [
      {
        heading: "行业现状",
        paragraphs: [
          "低端传统运维岗位加速淘汰，AI运维成为行业增长核心，人才缺口持续走高。据拉勾《2026运维行业人才白皮书》数据，近三年间基础运维岗位招聘量下滑65%；伴随企业上云与智能化改造，75%-85%的日常运维服务将被AI工具替代。Gartner报告显示，2026年已有63%的大中型企业落地AIOps智能运维体系，AI运维人才缺口达12万人，同比增速55.7%。",
        ],
      },
      {
        heading: "未来运维岗位主流方向",
        paragraphs: [
          "AI智能运维（AIOps）：核心负责AI平台部署、故障智能预测、自动化排障，是行业高薪方向。Gartner预测，2026年60%的大型企业将全面采用AIOps，头部企业资深岗位年薪可达35万元以上。",
          "云原生运维（SRE/DevOps）：主打容器化和CI/CD流水线搭建，是企业上云的刚需岗位。",
          "安全运维：聚焦漏洞检测、应急响应和等保合规，是较为稳定的方向。金融、政企需求旺盛，薪资较传统运维更具竞争力。",
        ],
      },
      {
        heading: "运维薪资变化趋势",
        paragraphs: [
          "前程无忧2026年IT薪酬报告显示，传统运维0-1年薪资约6K-10K，3-5年约12K-15K；AI运维0-1年约10K-13K，3-5年约20K-30K，资深专家可达35K以上；云原生运维0-1年约8K-12K，3-5年约20K-30K，架构岗位可达40K以上；安全运维0-1年约9K-12K，3-5年约18K-25K。",
        ],
      },
      {
        heading: "学习与转岗建议",
        paragraphs: [
          "在岗传统运维需要尽快摒弃手工思维，重点补充Python自动化、AIOps平台应用等核心技能。零基础求职者可以直接选择AI运维方向入行，避开低端岗位的同质化竞争。",
          "鑫谷程序员AI运维课程紧扣企业需求，聚焦Linux高阶、Python自动化和AIOps项目实战，为希望进入高薪稳定运维岗位的学习者提供系统化路径。",
          "实际案例中，张同学此前在一线城市从事机房运维，月薪7K。明确转向AI算力与GPU运维后，通过1.5个月学习Linux高阶、Python自动化、GPU服务器运维、企业级监控与日志平台，并参与真实商业项目实操，现已入职北京某AI算力服务商，薪资较此前翻了一倍多。",
        ],
      },
      {
        heading: "运维岗位会被AI淘汰吗？",
        paragraphs: [
          "不会。AI会替代基础重复工作，同时也会催生更多新岗位，懂AI的运维人才将更有价值。未来数年内，运维岗位的机遇仍大于挑战。避开低端传统运维赛道，以前沿技术构筑长期就业能力，是更具确定性的职业选择。",
        ],
      },
    ],
  },
  {
    slug: "ai-talent-lifecycle",
    title: "深耕AI数智人才，建立IT全年龄产业链",
    date: "2026.05.08",
    tag: "行业规划",
    image: "/images/news/bnaner.jpg",
    sections: [
      {
        paragraphs: [
          "数字经济浪潮下，IT行业已成为驱动产业升级的核心引擎，技术迭代加速与人才供需失衡的矛盾日益凸显。当前，我国IT培训行业已进入高质量发展阶段，AI、大数据、云计算等新兴领域人才缺口持续扩大。国家层面密集释放政策红利，《“人工智能+教育”行动计划》《加快数字人才培育支撑数字经济发展行动方案（2024-2026年）》等文件相继出台，为行业发展指明方向。",
          "在此背景下，鑫谷程序员以“深耕AI数智人才，建立IT全年龄产业链”为核心战略，聚焦青年零基础入行、中年职场转型、资深进阶群体，从人才分层培养、课程体系迭代、产教融合升级、就业生态构建四大维度发力，打造覆盖全年龄段、全技能层级的IT人才培养闭环。",
        ],
      },
      {
        heading: "洞察行业趋势，锚定全年龄培养定位",
        paragraphs: [
          "当前IT就业市场呈现“青年刚需入行、中年转型突破、资深进阶增值”的差异化需求。鑫谷程序员精准洞察行业趋势，打破大班授课难以精准赋能学员职业发展的局限，搭建全年龄段、分层级、个性化的人才培养体系。",
          "青年入行：针对应届生、零基础人群，聚焦企业刚需技术，提供“短、实、新”实战课程，帮助学习者快速入门、夯实基础。",
          "中年转型：面向传统IT从业者、职场转行者，打造AI技术升级、跨领域融合课程，帮助学习者突破职业瓶颈。",
          "资深进阶：针对在职专家、架构师开设高阶技术课程，赋能技术创新与职业晋升，匹配行业高端人才需求。",
        ],
      },
      {
        heading: "把脉技术前沿，迭代全品类课程矩阵",
        paragraphs: [
          "AI技术的快速发展推动IT行业人才需求从传统开发向AI复合型人才转型。鑫谷程序员持续优化课程体系，形成覆盖AI设计、AI运维、AI大模型、Java开发、AI智能应用等方向的核心课程矩阵。教学采用“理论+真机实操+企业项目”模式，将企业真实场景转化为教学案例，确保学员所学贴近企业实际需要。",
        ],
      },
      {
        heading: "深化产教融合，打通全链路就业生态",
        paragraphs: [
          "鑫谷程序员联动北京、山东、江苏等多省科技企业、AI算力服务商和互联网企业，建立“校企共建、资源共享、人才共育”的协同育人机制。一方面聘用企业一线技术专家参与课程研发与授课，将最新技术标准和项目流程融入教学；另一方面与企业共建人才输送通道，为学员提供实习、内推、就业一站式服务。",
          "针对不同基础的学员，品牌定制差异化学习与就业方案，实现“人人有路径，个个有发展”。未来，鑫谷程序员将持续优化分层培养体系、迭代前沿课程矩阵、深化产教融合生态，打通从青年入行到资深专家进阶的全周期成长通道。",
        ],
      },
    ],
  },
  {
    slug: "ai-vocational-education-opportunity",
    title: "IT职教风口下的AI新机遇：鑫谷程序员以全维度AI培养体系成就人才新未来",
    date: "2026.06.06",
    tag: "特别推荐",
    image: "/images/轮播2-2.jpg",
    lead: "当前国内AI产业高速落地、职业教育政策持续利好，但IT就业市场结构性矛盾愈发突出，AI实战人才稀缺。鑫谷程序员聚焦AI实战教学，依托产业资源、迭代课程体系和完善就业服务，为数字行业输送复合型技术人才。",
    sections: [
      {
        heading: "行业现状：AI产业爆发，催生全新人才供需矛盾",
        paragraphs: [
          "2026年国内数字经济与AI产业进入规模化落地阶段，行业人才缺口持续扩大。据相关行业报告，国内大模型市场规模和AI相关岗位招聘量快速增长，全国AI复合型技术人才仍存在较大缺口。",
          "与此同时，传统编程岗位竞争日趋激烈，部分基础工作受到AI工具影响。多数从业者缺乏AI项目实战能力，技能与企业最新用工标准脱节，这也让专业化AI职业教育成为新的就业需求。",
        ],
      },
      {
        heading: "核心优势：搭建全维度AI人才培养体系",
        paragraphs: [
          "鑫谷程序员紧扣企业用人标准，打造适配市场的AI职教培养体系。目前已与多家高校共建AI智能开发、大模型应用、Java+AI全栈等人工智能相关专业，并与IT企业开展生态合作，将企业真实商用项目融入课程，匹配企业招聘核心要求。",
        ],
      },
      {
        heading: "教学革新：真实商用项目驱动教学",
        paragraphs: [
          "针对零基础学员自学难、缺少项目和落地能力不足等问题，鑫谷程序员搭建标准化前沿课程体系。教学团队紧跟行业迭代，以月度为节点更新课程内容，坚持以真实商用项目驱动教学。",
          "学员通过系统化课程学习与全程实战实训，可以积累完整的前沿技术项目履历，补足自学短板，提升职场核心竞争力。",
        ],
      },
      {
        heading: "就业赋能：建立一站式就业服务体系",
        paragraphs: [
          "鑫谷程序员以高质量就业为目标，搭建简历优化、模拟面试、企业内推、专场双选会等全流程服务，实现“一地学习、全国就业”。通过持续对标行业需求迭代课程，以真实项目夯实实操能力，并以全链路就业服务帮助学员打通求职环节。",
          "未来，鑫谷程序员将继续深耕AI职业教育，为产业输送高质量技术人才，助力更多学习者凭借扎实的AI技能实现职业成长。",
        ],
      },
    ],
  },
];

export const news = newsArticles.slice(0, 3);
export const featuredNews = newsArticles[3];

export function findNewsBySlug(slug) {
  return newsArticles.find((article) => article.slug === slug);
}
